import { FC, useEffect, useState } from "react";
import { getAllTags } from "../../../services/api/admin/tags";

import Select from "..";

import styles from "./styles.module.scss";

type TagOption = {
    label: string;
    value: string;
};

type Props = {
    value?: string[];
    onChange: (selected: string[]) => void;
};

const TagSelect: FC<Props> = ({ value = [], onChange }) => {
    const [tags, setTags] = useState<TagOption[]>([]);

    useEffect(() => {
        getAllTags().then((tags) => {
            const options =
                tags?.map((tag) => ({
                    label: tag.name,
                    value: tag.id,
                })) || [];
            setTags(options);
        });
    }, []);

    return (
        <Select
            type="multiple"
            classNameTrigger={styles.trigger}
            value={value}
            onChange={(selected) => onChange(selected as string[])}
            options={tags}
        />
    );
};

export default TagSelect;
